<template>
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="col-md-12">
      <div class="card card-custom card-stretch gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title font-weight-bolder">
            {{
              $t("panelWidget.title", {
                title: pack.title,
                days: formatDays(pack.expire),
              })
            }}
          </h3>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body d-flex flex-column">
          <div class="flex-grow-1">
            <div class="row justify-content-center mb-2">
              <v-app style="max-height: 120px">
                <v-progress-circular
                  :rotate="360"
                  :size="100"
                  :width="15"
                  :value="expire"
                  color="teal"
                >
                  {{
                    expire === "∞"
                      ? $t("panelWidget.infinity")
                      : $t("panelWidget.percentage", {
                          value: formatNumber(expire),
                        })
                  }}
                </v-progress-circular>
              </v-app>
            </div>
            <div class="resize-triggers">
              <div class="expand-trigger"><div></div></div>
              <div class="contract-trigger"></div>
            </div>
          </div>
          <div class="pt-1">
            <p class="text-center font-weight-normal font-size-lg pb-7">
              {{ $t("panelWidget.renewPrompt") }}
            </p>
            <v-btn to="/panel" class="btn-buy" block>{{
              $t("panelWidget.buyPanel")
            }}</v-btn>
          </div>
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import i18n from "@/i18n";

export default {
  name: "Widget13",
  data() {
    return {
      loading: false,
      pack: [],
      expire: null,
    };
  },
  components: {
    Dropdown2,
  },
  i18n,
  mounted() {
    this.getPanel();
  },
  methods: {
    getPanel() {
      this.requestApiGet("currentPack").then((response) => {
        this.pack = response.data;
        let myDate = this.pack.expired_at;
        this.fillExpire(myDate);
      });
    },
    fillExpire(expire_date) {
      if (!expire_date) {
        this.expire = "∞";
        return;
      }
      var expireDate = new Date(expire_date).getTime();
      let now = new Date().getTime();
      let diff = this.datediff(now, expireDate);
      this.expire = Math.max(
        Math.round(100 - ((this.pack.expire - diff) / this.pack.expire) * 100),
        0
      );
    },
    formatNumber(value) {
      // Replace persian filter with locale-aware formatting
      const formatter = new Intl.NumberFormat(this.$i18n.locale, {
        style: "decimal",
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
    formatDays(count) {
      return this.$t("panelWidget.days", { count });
    },
  },
};
</script>
